import type { Article } from '../@types/ArticleV2';
import { resolveArticlesRoute } from '../routes/utils';
import * as settings from './settings';

export const slugify = (str: string) => {
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.toLowerCase();

  const from = 'àáäåâèéëêìíïîòóöôšùúüûñç·/_,:;';
  const to = 'aaaaaeeeeiiiioooosuuuunc------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

  return str;
};

interface VehicleDocument {
  id: string;
  title: string;
  shortDescription?: string | null;
  gearboxType?: string;
}

export const createItemUrl = (document?: VehicleDocument | null) => {
  if (!document) return '/objekt/-/-';

  const parts = [];
  if (document.title) parts.push(document.title);

  if (document.shortDescription) parts.push(document.shortDescription);

  if (document.gearboxType) parts.push(document.gearboxType);

  return parts.length
    ? `/objekt/${document.id}/${slugify(parts.join('-'))}`
    : `/objekt/${document.id}/-`;
};

export const createArticleUrl = (article: Article) =>
  `/${resolveArticlesRoute()}/${article.categories[0].slug}/${article.slug}`;

interface ExtractedQueryVar {
  key: string;
  value: string;
}

export const extractQueryVars = (url: string) => {
  const variables = url.split('&');
  const buffer: ExtractedQueryVar[] = [];

  variables.forEach((token) => {
    const parts = token.split('=');
    if (parts.length === 2 && parts[1]) {
      buffer.push({
        key: parts[0],
        value: parts[1],
      });
    }
  });

  return buffer;
};

export const cleanup = (url: string, patterns: string[]) => {
  const queryStringStart = url.indexOf('?');
  if (queryStringStart < 0 || !patterns || patterns.length === 0) {
    return url.replace(/\/+$/, '');
  }

  const queryString = url.substr(queryStringStart + 1);
  const params = extractQueryVars(queryString).filter(
    (param) => patterns.filter((pattern) => param.key.indexOf(pattern) >= 0).length === 0,
  );
  const nextQueryString =
    params.length === 0 ? '' : `?${params.map((p) => `${p.key}=${p.value}`).join('&')}`;
  return `${url.substr(0, queryStringStart)}`.replace(/\/+$/, '') + nextQueryString;
};

const prefix = (url: string) => {
  if (url[0] === '/') {
    return `${settings.get('CdnHost')}${settings.get('CdnPrefix')}${url}`;
  }
  return `${settings.get('CdnHost')}${url.substring(url.indexOf('/media'))}`;
};

const appendDimensions = (url: string, dimensions: string) => {
  const onlyWidth = dimensions.match(/x$/);
  const onlyHeight = dimensions.match(/^x/);
  const format = dimensions
    .toLowerCase()
    .split('x')
    .filter((f) => !!f);
  const separator = url.indexOf('?') >= 0 ? '&' : '?';

  if (onlyWidth) return `${url}${separator}w=${format[0]}`;
  if (onlyHeight) return `${url}${separator}h=${format[0]}`;

  return `${url}${separator}w=${format[0]}&h=${format[1]}`;
};

export const cdn = (url: string, dimensions: string | null = null) => {
  let result = url;

  if (url && settings.get('CdnHost')) {
    result = prefix(url);
  }

  if (dimensions) return appendDimensions(result, dimensions);

  return result;
};
